/**
 * Mirrors the backend `FileMediaType` discriminator exposed on every serialized
 * file (`FileDto` / `FileResponseDto`). An "Audio File" is a regular Files row
 * under the "Audio Assessment" category, so `MediaType` is what tells it apart
 * from a document without hardcoding FileCategory ids.
 */
export enum FileMediaType {
  AUDIO = 'Audio',
  DOCUMENT = 'Document',
}
